export const LANA_SETTINGS_LOCAL_STORAGE_KEY = 'lana-settings';
